var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
document.addEventListener('DOMContentLoaded', function() {
    const headerSearch = document.querySelector('.header__search');
    const originalParent = headerSearch.parentNode;
    const originalNextSibling = headerSearch.nextSibling;
    const targetElement = document.querySelector('div.custom-add-search-after');
    
    function moveHeaderSearch() {
        if (window.innerWidth < 990) {
            // Move after div.custom-add-search-after if not already there
            if (headerSearch.parentNode !== targetElement.parentNode || 
                headerSearch.previousElementSibling !== targetElement) {
                targetElement.after(headerSearch);
            }
        } else {
            // Return to original position if not already there
            if (headerSearch.parentNode !== originalParent || 
                headerSearch.nextSibling !== originalNextSibling) {
                if (originalNextSibling) {
                    originalParent.insertBefore(headerSearch, originalNextSibling);
                } else {
                    originalParent.appendChild(headerSearch);
                }
            }
        }
    }
    
    // Initial check
    moveHeaderSearch();
    
    // Add resize event listener
    window.addEventListener('resize', moveHeaderSearch);
});